export enum DeviceType {
  Unknown = 'Unknown',
  Ethernet = 'Ethernet',
  Wifi = 'Wifi',
  Bt = 'Bt',
  OlpcMesh = 'OlpcMesh',
  Wimax = 'Wimax',
  Modem = 'Modem',
  Infiniband = 'Infiniband',
  Bond = 'Bond',
  Vlan = 'Vlan',
  Adsl = 'Adsl',
  Bridge = 'Bridge',
  Generic = 'Generic',
  Team = 'Team',
  Tun = 'Tun',
  IpTunnel = 'IpTunnel',
  Macvlan = 'Macvlan',
  Vxlan = 'Vxlan',
  Veth = 'Veth',
  Macsec = 'Macsec',
  Dummy = 'Dummy',
  Ppp = 'Ppp',
  OvsInterface = 'OvsInterface',
  OvsPort = 'OvsPort',
  OvsBridge = 'OvsBridge',
  Wpan = 'Wpan',
  SixLowpan = '6lowpan',
  Wireguard = 'Wireguard',
  WifiP2p = 'WifiP2p',
}

export const DeviceTypeMetadata: Map<DeviceType, any> = new Map([
  [DeviceType.Unknown, {
    label: 'Unknown',
    icon: 'mdi-merge',
  }],
  [DeviceType.Ethernet, {
    label: 'Ethernet',
    icon: 'mdi-ethernet',
    ip: 'true',
  }],
  [DeviceType.Wifi, {
    label: 'Wifi',
    icon: 'mdi-wifi',
  }],
  [DeviceType.Bt, {
    label: 'Bt',
    icon: 'mdi-bluetooth',
  }],
  [DeviceType.OlpcMesh, {
    label: 'OLPC Mesh',
    icon: 'mdi-merge',
  }],
  [DeviceType.Wimax, {
    label: 'Wimax',
    icon: 'mdi-wifi-star',
  }],
  [DeviceType.Modem, {
    label: 'Modem',
    icon: 'mdi-merge',
  }],
  [DeviceType.Infiniband, {
    label: 'Infiniband',
    icon: 'mdi-merge',
  }],
  [DeviceType.Bond, {
    label: 'Bond',
    icon: 'mdi-merge',
  }],
  [DeviceType.Vlan, {
    label: 'VLAN',
    icon: 'mdi-ethernet-cable',
  }],
  [DeviceType.Adsl, {
    label: 'ADSL',
    icon: 'mdi-merge',
  }],
  [DeviceType.Bridge, {
    label: 'Bridge',
    icon: 'mdi-link',
    disabled: true,
  }],
  [DeviceType.Generic, {
    label: 'Generic',
    icon: 'mdi-merge',
  }],
  [DeviceType.Team, {
    label: 'Team',
    icon: 'mdi-merge',
  }],
  [DeviceType.Tun, {
    label: 'Tunnel',
    icon: 'mdi-merge',
  }],
  [DeviceType.IpTunnel, {
    label: 'IP Tunnel',
    icon: 'mdi-merge',
  }],
  [DeviceType.Macvlan, {
    label: 'MAC VLAN',
    icon: 'mdi-merge',
  }],
  [DeviceType.Vxlan, {
    label: 'VX LAN',
    icon: 'mdi-merge',
  }],
  [DeviceType.Veth, {
    label: 'Virtual ethernet',
    icon: 'mdi-merge',
  }],
  [DeviceType.Macsec, {
    label: 'MAC SEC',
    icon: 'mdi-merge',
  }],
  [DeviceType.Dummy, {
    label: 'Dummy',
    icon: 'mdi-merge',
  }],
  [DeviceType.Ppp, {
    label: 'PPP',
    icon: 'mdi-merge',
  }],
  [DeviceType.OvsInterface, {
    label: 'OVS Interface',
    icon: 'mdi-merge',
  }],
  [DeviceType.OvsPort, {
    label: 'OVS Port',
    icon: 'mdi-merge',
  }],
  [DeviceType.OvsBridge, {
    label: 'OVS Bridge',
    icon: 'mdi-merge',
  }],
  [DeviceType.Wpan, {
    label: 'WPAN',
    icon: 'mdi-merge',
  }],
  [DeviceType.SixLowpan, {
    label: '6LoWPAN',
    icon: 'mdi-merge',
  }],
  [DeviceType.Wireguard, {
    label: 'Wireguard',
    icon: 'mdi-vpn_lock',
  }],
  [DeviceType.WifiP2p, {
    label: 'Wifi P2P',
    icon: 'mdi-merge',
  }],
]);
